import React, { useContext } from 'react';
import { ELSIcon } from '@els/els-component-form-field-react';
import {
  getCompletedDate,
  getDueDate,
  getHourAndMinuteFromSecond,
  getTotalProgress,
  getTotalTimeSpentFromAssessmentMetrics,
  isTotalPLPComplete
} from '../../utilities/remediation.utilities';
import { FlexItem } from '../flex/FlexItem.component';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexLayoutModifier } from '../flex/flex.constants';
import {
  getProgressDisplay,
  getStatus
} from './due-date-progress.utilities';
import { iconConfigMap } from './due-date-progress.constants';
import { AppContext } from '../app/AppProvider.component';

export type DueDateProgressProps = Record<string, never>;

const DueDateProgress = (): JSX.Element => {

  const { appState } = useContext(AppContext);
  const baseState = appState.remediationBaseState;

  const totalProgress = getTotalProgress(baseState);
  const dueDate = getDueDate(baseState);
  const isComplete = isTotalPLPComplete(baseState);
  const dateCompleted = isComplete ? getCompletedDate(baseState) : null;
  const status = getStatus({ dueDate, isComplete, dateCompleted });
  const icon = iconConfigMap[status];
  const progressDisplay = getProgressDisplay({ status, dateCompleted, dueDate });
  const timeSpentSeconds = getTotalTimeSpentFromAssessmentMetrics(baseState?.assessmentMetrics)

  return (
    <div className={`c-nra-due-date-progress c-nra-due-date-progress--${status.toLowerCase()}`}>
      {progressDisplay && (
        <div className="c-nra-due-date-progress__box c-nra-due-date-progress__box--top">

          <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS, FlexLayoutModifier.MIDDLE]}>
            {
              icon && (
                <FlexItem>
                  <ELSIcon
                    name={icon.name}
                    prefix={icon.prefix}
                    size="1x1o2"
                    customClass="c-nra-due-date-progress__icon"
                  />
                </FlexItem>
              )
            }
            <FlexItem>
              <h4 className="c-nra-due-date-progress__title">{progressDisplay}</h4>
            </FlexItem>
          </FlexLayout>
        </div>
      )}


      <FlexLayout modifiers={[FlexLayoutModifier.MIDDLE]}>

        <FlexItem
          modifiers={[FlexLayoutModifier.GROW]}
          classes={['c-nra-due-date-progress__box', 'c-nra-due-date-progress__box--left']}>
          <div>Completion: <strong>{totalProgress}%</strong></div>
        </FlexItem>
        <FlexItem
          modifiers={[FlexLayoutModifier.GROW]}
          classes={['c-nra-due-date-progress__box']}
        >
          <div>Time spent: <strong>{getHourAndMinuteFromSecond(timeSpentSeconds)}</strong></div>
        </FlexItem>
      </FlexLayout>
    </div>
  );
};

export default DueDateProgress;
